import { CustomerSchema, InvoiceSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const GetCustomerInvoicePageDataResponseSchema = oz.object({
  customer: CustomerSchema.pick({
    name: true,
  }),
  invoice: InvoiceSchema.pick({
    name: true,
    billingStatus: true,
    reviewStatus: true,
  }),
}).openapi('GetCustomerInvoicePageDataResponse');

export type GetCustomerInvoicePageDataResponse = oz.infer<typeof GetCustomerInvoicePageDataResponseSchema>;